/**
 * Returns inner Height value for a specific container
 */

export default function getInnerHeight(item: HTMLElement): number {
    let totalHeight = item ? item.clientHeight : 0;
    if (item) {
        let computedStyle = getComputedStyle(item);

        totalHeight -=
            parseFloat(computedStyle.paddingTop) +
            parseFloat(computedStyle.paddingBottom) +
            parseFloat(computedStyle.borderTopWidth) +
            parseFloat(computedStyle.borderBottomWidth);
    }

    return totalHeight;
}
